export const GetBusinessValueParameters = {
  defaults: {
    "parameters": [
      {
        "@name": "cpes",
        "list": [
        ]
      }
    ]
  }
}
